import { render } from "./toggle.vue?vue&type=template&id=37329d2a"
import script from "./toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./toggle.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/form/toggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37329d2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37329d2a', __exports__)) {
    console.log('reload')
    api.reload('37329d2a', __exports__)
  }
  
  module.hot.accept("./toggle.vue?vue&type=template&id=37329d2a", () => {
    console.log('re-render')
    api.rerender('37329d2a', render)
  })

}


export default __exports__